import React from 'react'
import styled from 'styled-components'
import Select, { components } from 'react-select'
import { InputStyle, InputVariant } from './input'
import { ExpandDown } from '../icons'
import { colors } from '../../../styles/theme'

const StyledSelect = styled(Select)`
  color: ${props => props.theme.colors.typography.dark.text};
  font-weight: normal;
  width: 100%;

  .pac__value-container--is-multi {
    flex-wrap: nowrap;
  }

  .pac__control {
    ${InputStyle}
  }
`

const StyledContainer = styled.div`
  display: grid;
`

const MultiSelect = ({
  instanceId,
  variant,
  ...props
}: { instanceId: string; variant?: InputVariant } & any) => {
  return (
    <StyledSelect
      instanceId={instanceId}
      classNamePrefix="pac"
      isMulti
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator: () => <ExpandDown />,
        MultiValueContainer: props => (
          <StyledContainer>
            <components.MultiValueContainer {...props} />
          </StyledContainer>
        )
      }}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (base, state) => ({ ...base, zIndex: state.isFocused ? '9999' : '1' }),
        control: (base, state) => ({
          ...base,
          '&:hover': {}, // border style on hover
          border: `1px solid ${colors.neutral100}`, // default border color
          boxShadow: 'none' // no box-shadow
        })
      }}
      variant={variant}
      {...props}
    />
  )
}

export default MultiSelect
